export const PartsView = () => {
    return(
        <p>Example</p>
    )
}